import {
  FilterRequest,
  OrganizationDoc,
  OrganizationResponse,
  OrganizationsResponse,
  OrganizationsLightResponse,
  OrganizationPopulatedResponse,
} from '@/types/entities';
import { ApiService } from './api.service';
import { endpoints } from './endpoints';

/**
 * Service for handling organization-related API calls
 */
export class OrganizationsApiService extends ApiService {
  // Get all organizations (reference data)
  getAll = async (): Promise<OrganizationsLightResponse> => this.get(endpoints.organizations.all);

  getFilteredOrganizations = async (filters: FilterRequest): Promise<OrganizationsResponse> =>
    this.post(endpoints.organizations.filtered, filters);

  deleteOrganization = async (id: string): Promise<void> =>
    this.delete(endpoints.organizations.delete(id));

  getOrganizationById = async (
    id: string,
    populate = false
  ): Promise<OrganizationResponse | OrganizationPopulatedResponse> => {
    const queryParam = populate ? '?populate=true' : '';
    return this.get(`${endpoints.organizations.byId(id)}${queryParam}`);
  };

  createOrganization = async (data: Partial<OrganizationDoc>): Promise<OrganizationDoc> =>
    this.post(endpoints.organizations.create, data);

  updateOrganization = async (
    id: string,
    data: Partial<OrganizationDoc>
  ): Promise<OrganizationDoc> => this.patch(endpoints.organizations.update(id), data);
}

// Export a singleton instance
export const organizationsApiService = new OrganizationsApiService();

// Named exports for convenience
export const {
  getAll: getOrganizations,
  getFilteredOrganizations,
  deleteOrganization,
  getOrganizationById,
  createOrganization,
  updateOrganization,
} = organizationsApiService;
